import styled from "styled-components";

export const ButtonTextIconSquaredWrapper = styled.div`
  height: 2.8vw;
  border-radius: 0.3vw;
  display: flex;
  flex-direction: row;
  align-items: center;
  align-items: center;
  font-family: Atkinson Hyperlegible;
  font-size: 1vw;
  font-style: normal;
  font-weight: 700;
  line-height: 2.8vw;
  text-edge: cap;
  text-align: center;
  box-shadow: 0vw 0.2vw 0.7vw 0.2vw rgba(113, 109, 242, 0.1);
  padding-left: 0.4vw;
  box-sizing: border-box;
`;

export const IconButtonWrapper = styled.img`
  margin-right: 0.4vw;
  height: 1.9vw;
`;
